export const isDraggingBodyClass = 'is-dragging-tree-item';
